import React from 'react'

function ShowAdvancePayments() {
  return (
    <div>ShowAdvancePayments</div>
  )
}

export default ShowAdvancePayments